import PostPaywallUnlockAttemptModal from "@/components/modules/Post/Paywall/PostPaywallUnlockAttemptModal";
import { FixedNavbarBtnProps } from "@/types/ui-kit/buttons";
import { pushToDataLayer } from "@/utils/pushToDataLayer";
import Image from "next/image";
import React, { useState } from "react";

export const FixedNavbarUnlockButton: React.FC<FixedNavbarBtnProps> = ({ postTitle }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleUnlockButton = () => {
    // article_interaction (unlock)
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "unlock",
      media_url: postTitle ?? "article",
    });
    setIsDialogVisible(true);
  };

  return (
    <>
      <li className="w-full max-w-[78px] portrait:h-full">
        <span
          className="flex cursor-pointer flex-col items-center dark:text-white portrait:py-2 portrait:text-xs landscape:px-1.5 landscape:py-1.5 landscape:text-4xs"
          onClick={() => handleUnlockButton()}
        >
          <Image
            src="/assets/images/icons/new-unlock.svg"
            alt="Unlock Icon"
            width={20}
            height={20}
            className="mb-1 dark:invert landscape:h-[16px] landscape:w-[16px]"
          />
          Odemknout
        </span>
      </li>
      <PostPaywallUnlockAttemptModal isDialogVisible={isDialogVisible} setIsDialogVisible={setIsDialogVisible} />
    </>
  );
};
